module.exports = __webpack_public_path__ + "static/media/apple_mini.81c5acff.png";